import WeevilTrakComponent from "./WeevilTrak";

export default WeevilTrakComponent;